import { render, staticRenderFns } from "./WeeklyStores.vue?vue&type=template&id=7a24120c&lang=pug"
import script from "./WeeklyStores.vue?vue&type=script&lang=js"
export * from "./WeeklyStores.vue?vue&type=script&lang=js"
import style0 from "./WeeklyStores.vue?vue&type=style&index=0&id=7a24120c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports